import { BASE_URL, HTTPClientAuth } from '../../utils/httpClientAuth';
import { SSOClientAuth } from '../../utils/SSOClientAuth';
import { CustomerTeamDTO, ID, ProjectDTO, RoleDTO, UserGetAccessDTO } from '../types';

async function getAccess(values: UserGetAccessDTO) {
    try {
        const { data } = await HTTPClientAuth.post('/profile/dummy/get/access/', values);

        return data;
    } catch (error) {
        const { response } = error as any;

        return await Promise.reject((response as any)?.data);
    }
}

async function getProjects(): Promise<ProjectDTO[]> {
    const { data } = await HTTPClientAuth.get('/rollout/api/subproject/get_access/');

    return data;
}

async function getRolesByProject(id: ID): Promise<RoleDTO[]> {
    const { data } = await HTTPClientAuth.get(`/profile/api/rols/${id}/access_/`);

    return data;
}

async function getCustomerTeamsByProject(id: ID): Promise<CustomerTeamDTO[]> {
    const { data } = await HTTPClientAuth.get(`/rollout/api/subproject/${id}/customer_team/`);

    return data;
}

async function refreshToken() {
    const resp = await HTTPClientAuth.post('/api/refresh_token/', {
        refresh_token: localStorage.getItem('_rf_'),
        token: localStorage.getItem('_tk_'),
    });

    return resp.data;
}

async function login(username: string, password: string) {
    const resp = await HTTPClientAuth.post('/api/login_token/', {
        username,
        password,
    });

    return resp.data;
}

function validateToken() {
    return HTTPClientAuth.post('/token/validate/', {});
}

function getToken() {
    return SSOClientAuth.post('/sso/token/');
}

function redirectSSO() {
    window.location.href = `${BASE_URL}/sso/login/?next=/sso/validate/`;
}

function redirectSSOLogout() {
    window.location.href = `${BASE_URL}/sso/logout/`;
}

export {
    getAccess,
    getCustomerTeamsByProject,
    getProjects,
    getRolesByProject,
    getToken,
    login,
    redirectSSO,
    redirectSSOLogout,
    refreshToken,
    validateToken,
};
